import { Flex } from '@grupoboticario/flora-react';

import { CardContentSkeleton, Skeleton } from 'components';

import Styles from './ContentCarousel.styles';

export const ContentCarouselSkeleton = () => {
  return (
    <Flex direction='column' gap='$3'>
      <Skeleton height='$12' width='25%' />

      <Skeleton height='$7' width='50%' />

      <Styles.WithoutCarouselWrapper>
        {[...Array(3)].map((_, index) => (
          <CardContentSkeleton key={index} />
        ))}
      </Styles.WithoutCarouselWrapper>
    </Flex>
  );
};
